
export class SoundConstants
{
    public static GAME_MUSIC: string = "game_music";
    public static GAME_MUSIC_FON: string = "game_music_fon";
    public static MENU_MUSIC: string = "menu_music";
    public static BUTTON_CLICK: string = "button";
    public static BUTTON_DISABLED: string = "button_disabled";
    public static JUMP: string = "Jump";
    public static DOUBLE_JUMP: string = "Jump_Spin";
    public static CROWD_1: string = "Crowd_1";
    public static CROWD_2: string = "Crowd_2";
    public static CROWD_3: string = "Crowd_3";
    public static FOOTSTEP_1: string = "Footstep_1";
    public static FOOTSTEP_2: string = "Footstep_2";
    public static METAL_HIT: string = "Metal_Hit";
    public static WOODEN_HIT: string = "Wooden_Hit";
    public static NEW_RECORD: string = "new_record";
}

export class SoundLevels{
    public static levelAmbient: number = 0.2;
    public static levelMusic: number = 0.6;
    public static uiAction: number = 1;
    public static charAction: number = 1;
    public static crowdSound: number = 0.8;
    public static running: number = 0.8;
}

